import React from "react"
import { courses } from "../components/assets/data/dummydata"
import { FaBook } from "react-icons/fa"

import { useNavigate } from 'react-router-dom';

export const Courses = () => {
  const navigate = useNavigate();

  const handleCourseClick = (courseId) => {
    navigate(`/course/${courseId}`); // Navigate to course detail page
  };

  return (
    <>
      <section className='courses bg-[#F3F4F8] py-8'>
        <div className='w-4/5 m-auto'>
          <div className='heading mb-16'>
            <h1 className='text-3xl font-semibold text-black'>Our Courses</h1>
          </div>
          <div className='grid grid-cols-3 gap-8 md:grid-cols-1'>
            {courses.map((item) => (
              <div
                key={item.id}
                className='box rounded-lg shadow-md bg-white cursor-pointer'
                onClick={() => handleCourseClick(item.id)} // Handle course item click
              >
                <div className='images rounded-t-lg relative overflow-hidden h-40 w-full'>
                  <img
                    src={item.cover}
                    alt={item.title}
                    className='rounded-t-lg object-cover w-full h-full transition ease-in-out delay-150 hover:scale-110 duration-300'
                  />
                </div>
                <div className='text p-2'>
                  <h3 className='text-black my-4 font-medium'>{item.title}</h3>
                  <div className='flex items-center'>
                    <FaBook className='mr-2' />
                    <span className='text-[14px]'>All units</span>
                  </div>
                </div>
                <div className='flex justify-center mt-2'>
                  <button className='bg-primary text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-200'>
                    More Detail
                  </button>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};
